import { createFileRoute, Navigate } from '@tanstack/react-router';

import { routes } from 'shared/routes';

export const Route = createFileRoute('/')({
  component: () => <Navigate to={routes.signUp()} />
});
